import { useProfileData } from './useProfileData';

export const useUserCode = (): string => {
  const profileData = useProfileData();
  return `${profileData.paymentCode}`;
};
